import { cva } from '@/styled-system/css';

export const tagRecipe = cva({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'top',
  },
  variants: {
    tone: {
      critical: {
        backgroundColor: 'Tag.critical.bg',
        color: 'Tag.critical.text',
      },
      info: {
        backgroundColor: 'Tag.info.bg',
        color: 'Tag.info.text',
      },
      success: {
        backgroundColor: 'Tag.success.bg',
        color: 'Tag.success.text',
      },
      warning: {
        backgroundColor: 'bg.feedback.warning.soft',
        color: 'Tag.warning.text',
      },
      gray: {
        backgroundColor: 'bg.accent.gray.soft',
        color: 'Tag.gray.text',
      },
      green: {
        backgroundColor: 'bg.accent.green.soft',
        color: 'Tag.green.text',
      },
      purple: {
        backgroundColor: 'bg.accent.purple.soft',
        color: 'Tag.purple.text',
      },
      aqua: {
        backgroundColor: 'bg.accent.aqua.soft',
        color: 'Tag.aqua.text',
      },
      orange: {
        backgroundColor: 'bg.accent.orange.soft',
        color: 'Tag.orange.text',
      },
      transparent: {
        backgroundColor: 'transparent.black-60',
        color: 'text.onHero.neutral-fixed',
      },
      blue: {
        backgroundColor: 'bg.accent.blue.soft',
        color: 'Tag.blue.text',
      },
      teal: {
        backgroundColor: 'Tag.teal.bg',
        color: 'Tag.teal.text',
      },
      yellow: {
        backgroundColor: 'bg.feedback.warning.soft',
        color: 'Tag.yellow.text',
      },
      red: {
        backgroundColor: 'bg.accent.red.soft',
        color: 'Tag.red.text',
      },
    },
    size: {
      sm: {
        borderRadius: 'Tag.sm',
        paddingInline: 'tighter',
        paddingBlock: 'micro.default',
        gap: 'tightest',
      },
      md: {
        borderRadius: 'Tag.md',
        paddingInline: 'tighter',
        paddingBlock: 'micro.default',
        gap: 'tightest',
      },
    },
  },
});
